import styled from 'styled-components';

export const StepperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  border-bottom: 2px solid black;
  margin: 0.6rem 0 1rem 0;

  @media(max-width: 450px) {
    height: 35px;
  }

  @media(max-width: 350px) {
    height: 25px;
  }
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.step  === 1 ? 'flex-start' : props.step === props.steps ? 'flex-end' : 'center')};

  width: ${(props) => 100 / props.steps}%;

  & > .truck {
    width: 50%;
    margin-left: 1rem;
    position: relative;
    margin-bottom: 0.6rem;
    display: ${(props) => (props.percentage === (props.index + 1) * 100 / props.steps ? 'block' : 'none')};

    @media(max-width: 600px) {
      width: 100%;
    }
  }
`;
